import { QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "core/pages/ErrorBoundary";
import FallbackPage from "core/pages/Fallback.page";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { createRoot } from "react-dom/client";
import queryClient from "core/queryClient";
import { ClientProvider } from "clients";
import { StateProvider } from "state";
import { router } from "router";
import React from "react";
import { FeatureFlagProvider } from "core/providers/feature-flags-provider";
import "scss/main.scss";

import 'react-toastify/dist/ReactToastify.css';
import "@dynata/rex-raptor/dist/style.css";
import "@dynata/axiom3/dist/colors.css"
import "@dynata/axiom3/axiom.css"

// Start MSW, except for production
async function enableMocks() {
  if (import.meta.env.MODE === 'production')
    return;

  const { browser } = await import('@lib/api-mocks');

  return browser
    .worker({ 
      baseUrl: {
        managementBackend: import.meta.env.VITE_MANAGEMENT_URL
      }
    })
    .start({
      onUnhandledRequest: 'bypass'
    });
}

const container = document.getElementById("root");
const root = createRoot(container!)

enableMocks()
  .then(() => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary fallback={FallbackPage}>
          <ToastContainer />
          <StateProvider>
              <ClientProvider>
                <FeatureFlagProvider>
                  <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                  </QueryClientProvider>
                </FeatureFlagProvider>
              </ClientProvider>
          </StateProvider>
        </ErrorBoundary>
      </React.StrictMode>,
    )
  });
